import React from "react";
import { Spin } from "antd";
import { IIndexTypePresenter } from "../../presenter/IndexTypePresenter";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import IndexTypeGrid from "../components/IndexTypeGrid";

export interface Props extends PageProps {}

export interface State extends IIndexTypePresenter {}

export default class IndexTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      indexTypes,
      updateIndexType,
      deleteIndexType,
      onStartUpdateIndexType,
      indexTypeAttributes,
      createIndexTypeAttribute,
      deleteIndexTypeAttribute
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.indexTypeLoader}>
            <IndexTypeGrid
              indexTypes={indexTypes}
              translate={translate}
              updateIndexType={updateIndexType}
              deleteIndexType={deleteIndexType}
              onStartUpdateIndexType={onStartUpdateIndexType}
              indexTypeAttributes={indexTypeAttributes}
              createIndexTypeAttribute={createIndexTypeAttribute}
              deleteIndexTypeAttribute={deleteIndexTypeAttribute}
            />
          </Spin>
        }
      </Page>
    );
  }
}
